import React, { useEffect, useState } from 'react';
import { Inputs, SwitchComponent } from '../Controls';
import { showError, showSuccess } from '../../Helper';
import {
  CreateOrUpdatePropertyVideoInfo,
  CreateOrUpdateUnitVideoInfo,
  GetPropertyVideoInfo,
  GetUnitVideoInfo,
} from '../../Services';
import { ButtonBase } from '@material-ui/core';
import { Spinner } from '../SpinnerComponent/Spinner';

const initialVideoPublishData = {
  propertyId: null,
  categoryId: null,
  fileId: null,
  videoTitle: '',
  videoDescription: '',
  isPublished: false,
  isMarketing: false,
  isNeedOwnerApproval: false,
  isApproved: false,
  approveOwnerId: null,
  approvedById: null,
  approvalDate: null,
  comments: '',
  unitId: null,
  categoryName: '',
};

export const VideoPublishDetailsComponent = ({
  parentTranslationPath,
  activeVideo,
  translate,
}) => {
  const isUnit = !!activeVideo?.unitId;
  const [videoPublishData, setVideoPublishData] = useState(
    initialVideoPublishData
  );

  const [isLoading, setIsLoading] = useState(false);

  const handleSavePublishVideoInfo = async () => {
    setIsLoading(true);
    try {
      isUnit
        ? await CreateOrUpdateUnitVideoInfo(videoPublishData)
        : await CreateOrUpdatePropertyVideoInfo(videoPublishData);
      showSuccess('Changes saved successfully');
    } catch {
      showError('unable to save changes. Please try again.');
    }
    setIsLoading(false);
  };

  const getVideoInfo = async () => {
    setIsLoading(true);
    try {
      const res = isUnit
        ? await GetUnitVideoInfo(activeVideo)
        : await GetPropertyVideoInfo(activeVideo);
      if (res) {
        setVideoPublishData((prev) => ({ ...prev, ...res }));
      } else
        setVideoPublishData({
          ...initialVideoPublishData,
          propertyId: activeVideo?.propertyId,
          categoryId: activeVideo?.categoryId,
          fileId: activeVideo?.fileId,
          unitId: activeVideo?.unitId,
          categoryName: activeVideo?.categoryName,
          videoTitle: activeVideo?.categoryName,
          videoDescription: activeVideo?.categoryName,
        });
    } catch {
      showError('something went wrong. Please try again.');
    }
    setIsLoading(false);
  };

  const updateVideoPublishData = (field, value) => {
    setVideoPublishData((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    if (activeVideo) {
      const { propertyId, categoryId, fileId, unitId, categoryName } =
        activeVideo;
      setVideoPublishData((prev) => ({
        ...prev,
        propertyId: propertyId ?? null,
        unitId: unitId ?? null,
        categoryId,
        fileId,
        categoryName,
      }));
      getVideoInfo();
    }
  }, [activeVideo]);

  return (
    <div className='video-preview-inputs-wrapper'>
      <Spinner
        isActive={isLoading}
        isAbsolute
      />
      <Inputs
        idRef='videoTitleRef'
        labelValue='video-title'
        parentTranslationPath={parentTranslationPath}
        inputPlaceholder='video-title'
        value={videoPublishData.videoTitle}
        onInputChanged={(event) =>
          updateVideoPublishData('videoTitle', event.target.value)
        }
      />

      <Inputs
        idRef='videoDescriptionRef'
        labelValue='video-description'
        value={videoPublishData.videoDescription}
        parentTranslationPath={parentTranslationPath}
        inputPlaceholder='Notes...'
        multiline
        rows={5}
        onInputChanged={(event) =>
          updateVideoPublishData('videoDescription', event.target.value)
        }
      />

      <div>
        <div>
          <SwitchComponent
            idRef='PublishedRef'
            themeClass='theme-line'
            isChecked={videoPublishData.isPublished}
            labelValue='IsPublished'
            parentTranslationPath={parentTranslationPath}
            onChangeHandler={(_, isChecked) => {
              updateVideoPublishData('isPublished', isChecked);
              setVideoPublishData((prev) => ({
                ...prev,
                isMarketing: false,
              }));
            }}
          />
        </div>
        <div>
          <SwitchComponent
            idRef='MarketingRef'
            themeClass='theme-line'
            isChecked={videoPublishData.isMarketing}
            labelValue='isMarketing'
            parentTranslationPath={parentTranslationPath}
            onChangeHandler={(_, isChecked) => {
              updateVideoPublishData('isMarketing', isChecked);
            }}
            isDisabled={!videoPublishData.isPublished}
          />
        </div>
      </div>

      <hr className='divider' />
      <div>
        <div>
          <SwitchComponent
            idRef='OwnerApprovalRef'
            themeClass='theme-line'
            isChecked={videoPublishData.isNeedOwnerApproval}
            labelValue='Need-owner-approval'
            parentTranslationPath={parentTranslationPath}
            onChangeHandler={(_, isChecked) => {
              updateVideoPublishData('isNeedOwnerApproval', isChecked);
            }}
          />
        </div>
        {videoPublishData.isNeedOwnerApproval && (
          <div>
            <SwitchComponent
              idRef='ApprovedRef'
              themeClass='theme-line'
              isChecked={videoPublishData.isApproved}
              labelValue='IsApproved'
              parentTranslationPath={parentTranslationPath}
              onChangeHandler={(_, isChecked) => {
                updateVideoPublishData('isApproved', isChecked);
              }}
            />
          </div>
        )}
      </div>
      <Inputs
        idRef='CommentsRef'
        labelValue='Comments'
        inputPlaceholder='Comments'
        value={videoPublishData.comments}
        multiline
        rows={3}
        parentTranslationPath={parentTranslationPath}
        onInputChanged={(event) => {
          updateVideoPublishData('comments', event.target.value);
        }}
      />

      <div className='mt-1 d-inline-flex-center w-100'>
        <ButtonBase
          className='btns'
          onClick={handleSavePublishVideoInfo}
        >
          <span>
            <span className='mdi mdi-content-save-outline ' />
            {translate('Shared:save')}
          </span>
        </ButtonBase>
      </div>
    </div>
  );
};

export default VideoPublishDetailsComponent;
